import React from "react";

const WORDS = [
    "Residential",
    "Commercial",
    "Modular",
    "Turnkey",
    "Consultation",
    "Construction",
];

export const Marquee = () => {
    const row = [...WORDS, ...WORDS, ...WORDS];
    return (
        <div
            className="py-8 border-y border-[#1A1A1A]/15 bg-[#FAF9F6] overflow-hidden"
            data-testid="marquee"
        >
            <div className="marquee">
                <div className="marquee-inner">
                    {row.map((w, i) => (
                        <span
                            key={i}
                            className="font-serif text-3xl md:text-5xl text-[#1A1A1A] px-8 tracking-wide uppercase"
                            style={{ fontWeight: 500 }}
                        >
                            {w}
                            <span className="text-[#8C7C6D] mx-6">·</span>
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};
